<div class="delete-user">
  <h2
    *ngIf="selectedUser.length <= 1"
    class="headline">{{'USER_LIST.MODAL.DELETE_USER' | translate}}</h2>
  <h2
    *ngIf="selectedUser.length > 1"
    class="headline">{{'USER_LIST.MODAL.DELETE_USERS' | translate}}
  </h2>
  <p
    *ngIf="selectedUser.length <= 1"
    class="description">{{'USER_LIST.MODAL.DELETE_DESCRIPTION_1' | translate}}</p>
  <p
    *ngIf="selectedUser.length > 1"
    class="description">{{'USER_LIST.MODAL.DELETE_DESCRIPTION_2' | translate}}</p>
  <h3
    *ngIf="selectedUser.length <= 1"
    class="subtitle">{{userName}}</h3>

  <h3
    *ngIf="selectedUser.length > 1"
    class="subtitle">{{'USER_LIST.MODAL.DELETE_USER_COUNT' | translate}}: {{selectedUser.length}}</h3>
  <div class="btn-block">
    <button
      (click)="deleteUsers()"
      class="btn btn-danger">{{'USER_LIST.MODAL.DELETE_BUTTON' | translate}}</button>
    <button
      (click)="closeModal()"
      class="btn btn-light">{{'USER_LIST.MODAL.DELETE_CANCEL' | translate}}</button>
  </div>
</div>
